import { Injectable } from '@angular/core';

import { map, flatMap } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { IAirBookingResponse } from '../model/booking/air/IAirBookingResponse';
import { ApiResourceService } from '../../apiResource/apiResource.service';
import { IGroup } from "../model/group/IGroup";
import { ConfigurationResourceService } from "../configuration/configurationResource.service";
import { wenji } from 'libraries/interfaces/IWenji';

@Injectable()
export class GroupResourceService {

    constructor(private readonly apiResourceService: ApiResourceService,
        private readonly configurationResourceService: ConfigurationResourceService) {
    }

    // Work in progress
    public getTnr(id: string, _type: string = null): Observable<IGroup> {
        if (id.includes('*')) {
            const filename = id.slice(1) + '.json';
            return this.configurationResourceService.get(['wui', 'dummyDatas', filename]).pipe(
                map((response: any) => response));
        } else if(_type) {
                return this.apiResourceService.get<IAirBookingResponse>(
                    this.apiResourceService.getApiUrl('group', 'hosts', wenji.synchronyme.api.group.host, 'bookings', id),
                    { type: _type, merge: 'OSMAN' }, { target: wenji.synchronyme.api.group.target }
                ).pipe(map((response: any) => response));
        }
        return this.apiResourceService.get<IAirBookingResponse>(
            this.apiResourceService.getApiUrl('group', 'hosts', wenji.synchronyme.api.group.host, 'bookings', id),
            { merge: 'OSMAN' }, { target: wenji.synchronyme.api.group.target }
        ).pipe(map((response: any) => response));
        
    }

    /**
     * host : only GALILEO for now
     * §TODO : admin param page to choose GDS when it will be needed
     * @param {string} id
     * @return {Observable<any>}
     */
    public getPnr(id: string): Observable<any> {
        if (id.includes('*')) {
            const filename = id.slice(1) + '.json';
            return this.configurationResourceService.get(['wui', 'dummyDatas', filename]).pipe(
                map((response: any) => response));
        } else {
            return this.apiResourceService.get<any>(
                this.apiResourceService.getApiUrl('group', 'journeys'),
                { reference: id, host: 'GALILEO' }, { target: wenji.synchronyme.api.galileo.target }
            ).pipe(
                flatMap((response: any) => {
                    const fallback = Array.isArray(response) && response.length === 0;
                    if (fallback) {
                        return this.getHostBooking(id);
                    } else {
                        return response;
                    }
                })
            );
        }
    }

    public createPnr(query: any): Observable<any> {
        return this.apiResourceService.put(
            this.apiResourceService.getApiUrl('group', 'journeys'),
            query,
            {},
            { target: wenji.synchronyme.api.galileo.target }
        ).pipe(map((response: any) => response));
    }

    public getNameList(id): Observable<any> {
        return this.apiResourceService.get<any>(
            this.apiResourceService.getApiUrl('group', 'journeys', id),
            {},
            { target: wenji.synchronyme.api.galileo.target }
        ).pipe(map((response: any) => response));
    }


    public patchPnr(id, query): Observable<any> {
        return this.apiResourceService.patch(
            this.apiResourceService.getApiUrl('group', 'journeys', id),
            query,
            {},
            { target: wenji.synchronyme.api.galileo.target }
        ).pipe(map((response: any) => response));
    }

    public updateJourney(id, query): Observable<any> {
        return this.apiResourceService.post(
            this.apiResourceService.getApiUrl('group', 'journeys', id),
            query,
            {},
            { target: wenji.synchronyme.api.galileo.target }
        );
    }

    private getHostBooking(id): Observable<any> {
        if (id.includes('*')) {
            const filename = id.slice(1) + '.json';
            return this.configurationResourceService.get(['wui', 'dummyDatas', filename]).pipe(
                map((response: any) => response));
        } else {

            return this.apiResourceService.get<any>(
                this.apiResourceService.getApiUrl('group', 'hosts', 'GALILEO', 'bookings', id),
                {}, { target: wenji.synchronyme.api.galileo.target }
            ).pipe(map((response: any) => response));
        }
    }
}